import { render, staticRenderFns } from "./ImportStudent.vue?vue&type=template&id=0a568b66"
import script from "./ImportStudent.vue?vue&type=script&lang=js"
export * from "./ImportStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports